module.exports = __webpack_public_path__ + "file.svg?4bf3092ef837da566ce5a62fecf88a56";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/file.svg
// module id = 102
// module chunks = 0